import React from "react";

interface IPersonIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const PersonIcon: React.FC<IPersonIconProps> = ({ sizeX = 25, sizeY = 24 }) => {
    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M7.5 21V19C7.5 18.4696 7.71071 17.9609 8.08579 17.5858C8.46086 17.2107 8.96957 17 9.5 17H15.5C16.0304 17 16.5391 17.2107 16.9142 17.5858C17.2893 17.9609 17.5 18.4696 17.5 19V21M5.5 3H19.5C20.6046 3 21.5 3.89543 21.5 5V19C21.5 20.1046 20.6046 21 19.5 21H5.5C4.39543 21 3.5 20.1046 3.5 19V5C3.5 3.89543 4.39543 3 5.5 3ZM15.5 10C15.5 11.6569 14.1569 13 12.5 13C10.8431 13 9.5 11.6569 9.5 10C9.5 8.34315 10.8431 7 12.5 7C14.1569 7 15.5 8.34315 15.5 10Z"
                stroke="#D0BDF8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
    );
}
